import React, { createContext, useState } from "react";

const UIContext = createContext();

export const UIProvider = ({ children }) => {

    const [ isViewMenu, setIsViewMenu ] = useState(false);

    const handleToogleMenu = () => setIsViewMenu(!isViewMenu);

    const contextValue = {
        isViewMenu,
        handleToogleMenu
    }

    return (
        <UIContext.Provider value={contextValue}>{children}</UIContext.Provider>
    )

}

export default UIContext;